import { render, staticRenderFns } from "./add_form.vue?vue&type=template&id=95522976&scoped=true&"
import script from "./add_form.vue?vue&type=script&lang=js&"
export * from "./add_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95522976",
  null
  
)

export default component.exports